import React, { useState, useEffect } from "react";
import { getaxiosRequestWithToken, postaxiosRequestWithToken, FetchPatientMedicalProgram } from "../../api/api";
import CommonSpinner from "../../services/commonSpinner";
import { showToast } from "../../services/toastifyservices";
import { handleSession } from "../../api/apiSessionHandle";
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import PatientDetail from '../../components/Medical-Program/PatientDetails';
import { PaginationControls } from "../../components/pagination"
import SearchableSelect from '../../components/Medical-Program/SearchableSelect';
import { FaRegEdit } from "react-icons/fa";
import { FiShoppingBag, FiTrash2 } from 'react-icons/fi';
import Swal from "sweetalert2";
import endpoints from "../../api/EndPoints";

const ProgramRecords = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [MedicalPrograms, setMedicalPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState('');
  const [Providers, setProviders] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState("");
  const [date, setDate] = useState("");
  const [Programdata, setProgramdata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [SelectedRowRecoed, setSelectedRowRecoed] = useState(false);
  const [submitdata, setsubmitdata] = useState(null);
  const [IsNew, setIsNew] = useState(false);
  const [selectedPateintPoolId, setselectedPateintPoolId] = useState('');
  const [SelectedLastBillingDate, setSelectedLastBillingDate] = useState('');

  const [Data, setData] = useState('');
  const [SelectedRowRecord, setSelectedRowRecord] = useState('');

  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const pageCache = React.useRef({});
  // useEffect(() => {
  //   const today = new Date().toISOString().split("T")[0];
  //   setDate(today);
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([
        fetchProviders(),
        fetchMedicalPrograms(),

      ]);
      setLoading(false);
    };
    fetchData();
  }, []);

  const fetchMedicalPrograms = async () => {
    try {
      const response = await getaxiosRequestWithToken(endpoints.GetMedicalProgram);
      if (response.success) {
        
        setMedicalPrograms(response.data.medical_programs || []);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };

  const fetchProviders = async () => {
    try {
      const response = await getaxiosRequestWithToken(endpoints.FetchProvider);
      if (response.success) {
        setProviders(response.data.data || []);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    const Payload = {
      medical_program_id: selectedProgram,
      provider_id: selectedProviders,
      last_billing_date: SelectedLastBillingDate,
      patient_id: selectedPateintPoolId,
    };
    console.log("handleSearchPayload", Payload)
    try {
      const response = await postaxiosRequestWithToken(endpoints.GetPatientByMedicalProgram,Payload);
      if (response.success) {
        var responseData=response.data.data;
        setProgramdata([]);
        setProgramdata(responseData.data);
        setCurrentPage(responseData.current_page)
        setRowsPerPage(responseData.per_page);
        setTotalPages(Math.ceil(responseData.total / responseData.per_page))
      }
    } catch (error) {

      setProgramdata([]);
      showToast("error", error.response?.data.message);
      setLoading(false);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);

    }
  };

  const handleEdit = (rowData) => {
    var data = rowData;
    setSelectedRowRecord(data)
    setselectedPateintPoolId(data.patient_pool_id)
    setIsNew(false)
    setShowModal(true)
    setselectedPateintPoolId('');
  };

  const SaveData = async (data) => {
    setLoading(true);
    try {
      const payload = {
        id: SelectedRowRecord.id,
        status: 'active',
        medical_program_id: Number(data.medical_program_id),
        provider_id: String(data.provider_id),
        last_billing_date: data.last_billing_date,
      };

      const response = await postaxiosRequestWithToken(endpoints.UpdatePatientByMedicalProgram, payload);
      if (response.success) {
        showToast('success', response.data?.message || "Data saved successfully.");
        setShowModal(false);
        await handleSearch(); // Refresh data
      }
    } catch (error) {
      handleError(error);
      showToast('error', error.response?.data.message);

    } finally {
      setLoading(false);
    }
  }

  const handlePageChange = (page) => {

    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetch_Patient_Medical_Program(page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {

    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetch_Patient_Medical_Program(currentPage, newLimit);
  };
  const fetch_Patient_Medical_Program = async (page, limit = rowsPerPage) => {

    // if (pageCache.current[page]?.limit === limit) {
    //   const cachedData = pageCache.current[page];
    //   setProgramdata(cachedData.data);
    //   setCurrentPage(cachedData.current_page);
    //   setTotalPages(cachedData.last_page);
    //   setLoading(false);
    //   return;
    // }

    setLoading(true);
    try {
      const Payload = {
        medical_program_id: selectedProgram,
        provider_id: selectedProviders,
        last_billing_date: SelectedLastBillingDate,
      };
      const response = await FetchPatientMedicalProgram(page, Payload);
      if (response) {
        const { data, current_page, last_page } = response.data.data;
        const processedData = Array.isArray(data) && data.length > 0 ? data : [];
        setProgramdata(processedData);
        setCurrentPage(current_page);
        setTotalPages(last_page);
      }
    } catch (error) {
      handleSession(error.response?.data, navigate);
      showToast('error', error.response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = () => {
    
    // setIsNew(true)
    // setShowModal(true);
  };
  const handleDelete = async (documentId) => {
    Swal.fire({
      title: "Do you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      icon: "question"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const params = { id: documentId, status: 'inactive' };
          const response = await postaxiosRequestWithToken(endpoints.UpdatePatientByMedicalProgram, params);

          if (response.success) {
            showToast("success", "Document deleted successfully");
            await handleSearch();
          } else {
            showToast("error", response.message || "Failed to delete the document");
          }
        } catch (error) {
          showToast('error', error.response?.data.message);
        }
      }
    });
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Medical Program Records
        </span>
      </div>

      <form onSubmit={handleSearch}>
        <div className="card mt-3 py-2 px-3 ">
          <div className="row mt-3 mb-2  align-items-end">
            <div className="col-12 col-md-6 col-lg-3 mb-3" style={{ zIndex: 1050 }}>
              <label className="form-label font-bold mb-1">Search Patient</label>
              <SearchableSelect
                onChange={handleInputChange}
                setSelectedValue={setselectedPateintPoolId}
                styles={{ menu: (provided) => ({ ...provided, zIndex: 2000 }) }}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <label className="form-label font-bold mb-1">Providers</label>
              <select
                className="form-select"
                value={selectedProviders}
                onChange={(e) => setSelectedProviders(e.target.value)}
              >
                <option value="">Select Providers</option>
                {Providers.map((providers) => (
                  <option key={providers.id} value={providers.id}>
                    {providers.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <label className="form-label font-bold mb-1">Medical Program</label>
              <select
                className="form-select"
                value={selectedProgram}
                onChange={(e) => setSelectedProgram(e.target.value)}
              >
                <option value={''}>Select Medical Program</option>
                {MedicalPrograms.map((program) => (
                  <option key={program.id} value={program.id}>
                    {program.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <label className="form-label font-bold mb-1">Last Billing Date</label>
              <input
                type="date"
                className="form-control"
                value={SelectedLastBillingDate}
                onChange={(e) => setSelectedLastBillingDate(e.target.value)}
              />
            </div>

          </div>
          <div className="row">
            <div className="col-12 d-flex justify-content-end">
              
              <button className="btn btn-primary fw-bold btncolor" type="submit">
                Search
              </button>
            </div>
          </div>

        </div>
      </form>

      <div className="card mt-3">
        <div className="table-container table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-header">
              <tr>
                <th>Patient Name</th>
                <th>Provider Name</th>
                <th>Medical Program</th>
                <th>Consent Sign Date</th>
                <th>Last Billing Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Programdata.length > 0 ? (
                Programdata.map((data) => (
                  <tr key={data.id}>
                    <td>{data.patient_pool.first_name + ' ' + data.patient_pool.last_name}</td>
                    <td>{data.provider.name}</td>
                    <td>{data.medical_program.name}</td>
                    <td>{data.consent_sign_date}</td>
                    <td>{data.last_billing_date}</td>
                    <td>{data.status.charAt(0).toUpperCase() + data.status.slice(1)}</td>
                    <td>
                      {data.status.toLowerCase() === "active" && (
                        <>
                          <button
                            onClick={() => handleEdit(data)}
                            className="btn btn-link"
                            title="Edit Document"
                            style={{ color: 'green' }}
                          >
                            <FaRegEdit size={20} />
                          </button>
                          <button
                            onClick={() => handleDelete(data.id)}
                            className="btn btn-link"
                            title="Delete Document"
                            style={{ color: 'red' }}
                          >
                            <FiTrash2 size={20} />
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {loading || Programdata.length === 0 ? null : (
          <div className="pagination-controls">
            <PaginationControls
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => handlePageChange(page)}
              rowsPerPage={rowsPerPage}
              onLimitPerPage={handleRowsPerPageChange}
            />
          </div>
        )}
      </div>

      {loading && <CommonSpinner />}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Program</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          <PatientDetail
            patientPoolId={selectedPateintPoolId}
            medicalProgram={MedicalPrograms}
            providers={Providers}
            SubmitData={setData}
            SaveData={SaveData}
            loading={loading}
            medicalProgramId={SelectedRowRecord.medical_program_id}
            consentSignDate={SelectedRowRecord.consent_sign_date}
            lastBillingDate={SelectedRowRecord.last_billing_date}
            providerid={SelectedRowRecord.provider_id}
            IsNew={IsNew}
          />
        </Modal.Body>
      </Modal>
    </div>


  );
};

export default ProgramRecords;
